import React, { useState, useEffect, useContext } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { Layout, Button, Row, Col, Divider, Table, Radio, Input, Form } from "antd";
import { CheckOutlined } from "@ant-design/icons";
import {
  getPurchaseService,
  getSupplierService,
  getBillService,
  getMaterialService,
  completeBillService,
  getMetalsService,
  saveBillService,
} from "./NewBillPageService";
import Header from "../../components/Header/Header";
import Sidebar from "../../components/Sidebar/Sidebar";
import "./NewBillPage.css";
import Loader from "../../components/Loader/Loader";
import { removeTokenFromCookies } from "../../utils/cookies";
import Copyright from "../../components/Copyright/Copyright";
import TextArea from "antd/es/input/TextArea";
import Cookies from "universal-cookie";

const { Content } = Layout;

export interface NewBillPageProps {}

const NewBillPage = (props: NewBillPageProps) => {
  const [sidebarCollapsed, setSidebarCollapsed] = useState(true);
  const [loading, setLoading] = useState(true);
  const [bill, setBill] = useState({}) as any;
  const [purchase, setPurchase] = useState({}) as any;
  const [supplier, setSupplier] = useState({}) as any;
  const [materials, setMaterials] = useState([]) as any;
  const [tableFormatMaterials, setTableFormatMaterials] = useState([]) as any;
  const [totalPaymentAmount, setTotalPaymentAmount] = useState(0) as any;
  const [totalBillAmount, setTotalBillAmount] = useState(0) as any;
  const [cashAmount, setCashAmount] = useState("0.00");
  const [onlineAmount, setOnlineAmount] = useState("0.00");
  const [totalAmountFormMessage, setTotalAmountFormMessage] = useState("");
  const [notes, setNotes] = useState("");
  const [totalNetWeight, setTotalNetWeight] = useState(0.0);
  const [numMaterials, setNumMaterials] = useState(0);
  const [numWeighIns, setNumWeighIns] = useState(0);
  const [materialsBreakdown, setMaterialsBreakdown] = useState(false);
  const [cashAmountFormStatus, setCashAmountFormStatus] = useState("") as any;
  const [cashAmountFormMessage, setCashAmountFormMessage] = useState("");
  const [onlineAmountFormStatus, setOnlineAmountFormStatus] = useState("") as any;
  const [onlineAmountFormMessage, setOnlineAmountFormMessage] = useState("");
  let navigate = useNavigate();
  let location = useLocation();
  const cookies = new Cookies();
  const currOffice = cookies.get("CURR_OFFICE");
  const priceRegEx = /^\d+\.\d{2}$/;

  const billColumns = [
    {
      title: "Item Number",
      align: "center" as const,
      key: "itemNumber",
      render: (text: any, record: any, index: any) => index + 1,
    },
    {
      title: "Material Name",
      dataIndex: "name",
      align: "left" as const,
    },
    {
      title: "Net Weight (kg)",
      dataIndex: "netWeight",
      align: "center" as const,
      render: (record: any) => Number(record).toFixed(1),
    },
    {
      title: "Price (RM/kg)",
      align: "center" as const,
      render: (record: any) =>
        !ableToEditBill(bill.createdTimestamp) ? (
          <strong>{Number(record.price).toFixed(2)}</strong>
        ) : (
          <Form.Item validateStatus={record.priceFormStatus} help={record.priceFormMessage}>
            <Input
              placeholder="0.00"
              style={{ width: "120px", textAlign: "center" }}
              value={record.price}
              // value={record.price === "0" ? "0.00" : Number(record.price).toFixed(2)}
              onClick={(e) =>
                e.currentTarget.setSelectionRange(e.currentTarget.value.length, e.currentTarget.value.length)
              }
              onChange={(e) => {
                updateMaterialPrice(record, e.target.value);
              }}
            />
          </Form.Item>
        ),
    },
    {
      title: "Amount (RM)",
      key: "amount",
      align: "right" as const,
      render: (record: any) => (
        <span style={{ marginRight: "25px" }}>
          {record.amount ? Number(record.amount).toFixed(2) : calculateAmount(record)}
        </span>
      ),
    },
  ];

  useEffect(() => {
    navToSelectOffice();
    const billID = location.pathname.split("/")[2];
    getBill(billID);
  }, []);

  const navToSelectOffice = () => {
    if (currOffice === "" || currOffice === undefined || currOffice === null) navigate("/");
  };

  const navToLogin = () => {
    navigate("/login");
  };

  const getBill = async (billID: string) => {
    try {
      setLoading(true);
      const metals = await getMetals();
      const resBill = await getBillService(billID, currOffice);
      const resPurchase = await getPurchase(resBill.data.purchaseID);
      let currMaterials: any[] = [...materials];
      let currTableFormatMaterials: any[] = [...tableFormatMaterials];
      let currTotalNetWeight = 0.0;
      let currNumMaterials = 0;
      let currNumWeightIns = 0;
      for (let materialID of resPurchase?.data.materialIDList) {
        const resMaterial = await getMaterial(materialID);
        let currMaterial = resMaterial?.data;
        const metalInfo: any = metals.find((metal: any) => metal.metalID === currMaterial.metalID);
        console.log("currMaterial", currMaterial);
        currMaterial.price = Number(currMaterial.price).toFixed(2);
        currMaterial.displayName = metalInfo.displayName;
        currMaterial.name = metalInfo.name;
        currMaterial.key = currMaterial.materialID;
        currMaterial.priceFormStatus = "";
        currMaterial.priceFormMessage = "";
        currMaterials.push({ ...currMaterial });
        const materialIfExists = currTableFormatMaterials.find(
          (material: any) => material.metalID === currMaterial.metalID
        );
        if (materialIfExists) {
          // const totalNetWeight = Number(materialIfExists.netWeight) + Number(currMaterial.netWeight);
          materialIfExists.netWeight = (Number(materialIfExists.netWeight) + Number(currMaterial.netWeight)).toFixed(1);
        } else {
          currTableFormatMaterials.push({ ...currMaterial });
          currNumMaterials += 1;
        }
        currTotalNetWeight += Number(currMaterial.netWeight);
        currNumWeightIns += 1;
      }
      const resSupplier = await getSupplier(resPurchase?.data.supplierID);
      setBill(resBill.data);
      setPurchase(resPurchase?.data);
      setSupplier(resSupplier?.data);
      // currMaterials.sort((a, b) => a.displayName.localeCompare(b.displayName));
      // currTableFormatMaterials.sort((a, b) => a.displayName.localeCompare(b.displayName));
      setTotalNetWeight(currTotalNetWeight);
      setMaterials(currMaterials);
      setTableFormatMaterials(currTableFormatMaterials);
      setNotes(resBill.data.notes);
      setNumMaterials(currNumMaterials);
      setNumWeighIns(currNumWeightIns);
      console.log("bill", bill);
      setCashAmount(Number(resBill.data.cashAmount).toFixed(2));
      setOnlineAmount(Number(resBill.data.onlineAmount).toFixed(2));
      // getTotalBillAmount();
      setLoading(false);
    } catch (e: any) {
      setLoading(false);
      console.error("getBill error", e);
      if (e.response.status === 401) {
        removeTokenFromCookies();
        navToLogin();
      }
    }
  };

  const getPurchase = async (purchaseID: string) => {
    try {
      setLoading(true);
      const res = await getPurchaseService(currOffice, purchaseID);
      setLoading(false);
      return res;
    } catch (e: any) {
      setLoading(false);
      console.error("getPurchases error", e);
      if (e.response.status === 401) {
        removeTokenFromCookies();
        navToLogin();
      }
    }
  };

  const getMaterial = async (materialID: string) => {
    try {
      setLoading(true);
      const res = await getMaterialService(materialID);
      setLoading(false);
      return res;
    } catch (e: any) {
      setLoading(false);
      console.error("getPurchases error", e);
      if (e.response.status === 401) {
        removeTokenFromCookies();
        navToLogin();
      }
    }
  };

  const getSupplier = async (supplierID: string) => {
    try {
      setLoading(true);
      const res = await getSupplierService(supplierID);
      setLoading(false);
      return res;
    } catch (e: any) {
      setLoading(false);
      console.error("getSuppliers error", e);
      if (e.response.status === 401) {
        removeTokenFromCookies();
        navToLogin();
      }
    }
  };

  const getMetals = async () => {
    try {
      setLoading(true);
      const res = await getMetalsService();
      setLoading(false);
      return res.data;
    } catch (e: any) {
      setLoading(false);
      console.error("getMetals error", e);
      if (e.response.status === 401) {
        removeTokenFromCookies();
        navToLogin();
      }
    }
  };

  const completeBill = async () => {
    try {
      setLoading(true);
      const payload = {
        billID: bill.billID,
        purchaseID: purchase.purchaseID,
        materials: materials,
        totalAmount: totalPaymentAmount,
        supplier: supplier,
        cashAmount: Number(cashAmount),
        onlineAmount: Number(onlineAmount),
        paymentMethod: getPaymentMethod(),
        notes: notes,
        billNumber: bill.billNumber,
        aggregateMaterials: tableFormatMaterials,
        purchaseCreatedTimestamp: bill.purchaseCreatedTimestamp,
      };
      const res = await completeBillService(bill.billID, payload);
      setLoading(false);
      navigate(`/bills`);
    } catch (e: any) {
      setLoading(false);
      console.error("completeBill error", e);
      if (e.response.status === 401) {
        removeTokenFromCookies();
        navToLogin();
      }
    }
  };

  const saveBill = async () => {
    try {
      setLoading(true);
      let materialsList = [...materials];
      materialsList.forEach((material: any) => {
        if (Number(material.price) <= 0.0) {
          material.price = 0.0;
        }
      });
      //check if totalAmount, cashAmount, onlineAmount is above 0
      const payload = {
        billID: bill.billID,
        materials: materials,
        totalAmount: totalPaymentAmount,
        cashAmount: Number(cashAmount),
        onlineAmount: Number(onlineAmount),
        paymentMethod: getPaymentMethod(),
        notes: notes,
      };
      const res = await saveBillService(bill.billID, payload);
      setLoading(false);
    } catch (e: any) {
      setLoading(false);
      console.error("saveBill error", e);
      if (e.response.status === 401) {
        removeTokenFromCookies();
        navToLogin();
      }
    }
  };

  const updateMaterialPrice = (record: any, price: any) => {
    record.priceFormStatus = "";
    record.priceFormMessage = "";
    const currMaterials = [...materials];
    currMaterials.forEach((material: any) => {
      if (!priceRegEx.test(price)) {
        record.priceFormStatus = "error";
        record.priceFormMessage = "Price must have 2 decimal places. Example RM 0.00";
      }
      if (material.metalID === record.metalID) {
        material.price = price;
        material.amount = price * material.netWeight;
      }
    });
    setMaterials(currMaterials);
    const currTableFormatMaterials = [...tableFormatMaterials];
    const updateTableFormatMaterial = currTableFormatMaterials.find(
      (material: any) => material.metalID === record.metalID
    );
    updateTableFormatMaterial.price = price;
    updateTableFormatMaterial.amount = price * updateTableFormatMaterial.netWeight;
    setTableFormatMaterials(currTableFormatMaterials);
    getTotalBillAmount();
  };

  const calculateAmount = (record: any) => {
    getTotalBillAmount();
    return (Number(record.netWeight) * Number(record.price)).toFixed(2);
  };

  const toggleSidebar = (collapsed: boolean) => {
    setSidebarCollapsed(collapsed);
  };

  const viewPurchase = () => {
    navigate(`/purchase/${bill.purchaseID}`);
  };

  const showMaterialsBreakdown = () => {
    setMaterialsBreakdown(true);
  };

  const hideMaterialsBreakdown = () => {
    setMaterialsBreakdown(false);
  };

  const getTotalBillAmount = () => {
    let totalAmountMaterials = 0;
    let totalAmountTableFormatMaterials = 0;

    materials.forEach((material: any) => {
      totalAmountMaterials += Number((Number(material.price) * Number(material.netWeight)).toFixed(2));
    });

    tableFormatMaterials.forEach((material2: any) => {
      totalAmountTableFormatMaterials += Number((Number(material2.price) * Number(material2.netWeight)).toFixed(2));
    });
    // const penniesr1 = totalAmountMaterials * 100;
    // const moneyr1 = Math.round(penniesr1) / 100;
    // const penniesr2 = totalAmountTableFormatMaterials * 100;
    // const moneyr2 = Math.round(penniesr2) / 100;
    // console.log("totalAmountMaterials", totalAmountMaterials.toFixed(2));
    // console.log("totalAmountTableFormatMaterials", totalAmountTableFormatMaterials.toFixed(2));
    // console.log("totalAmountMaterials moneyr1", moneyr1);
    // console.log("totalAmountTableFormatMaterials moneyr2", moneyr2);
    // updateCashAmount(parseFloat(String(totalAmountMaterials)).toFixed(2));

    setTotalBillAmount(Number(parseFloat(String(totalAmountMaterials)).toFixed(2)));
  };

  const validateCompleteBillForm = () => {
    let materialsList = [...materials];
    let tableFormatMaterialsList = [...tableFormatMaterials];
    let validationFormStatus = true;
    let currList = materialsBreakdown ? materialsList : tableFormatMaterialsList;
    currList.forEach((material: any) => {
      if (!priceRegEx.test(material.price)) {
        validationFormStatus = false;
        material.priceFormStatus = "error";
        material.priceFormMessage = "Price must have 2 decimal places. Example RM 0.00";
      } else if (Number(material.price) <= 0.0) {
        validationFormStatus = false;
        material.priceFormStatus = "error";
        material.priceFormMessage = "Price has to more than 0.00";
      }
    });
    setMaterials(materialsList);
    if (Number(Math.abs(totalBillAmount - totalPaymentAmount).toFixed(2)) >= 1.0) {
      validationFormStatus = false;
      setTotalAmountFormMessage("Total Bill and Total Payment does not tally");
    }
    if (!priceRegEx.test(cashAmount)) {
      validationFormStatus = false;
      setCashAmountFormStatus("error");
      setCashAmountFormMessage("Amount must have 2 decimal places. Example RM 0.00");
    }
    if (!priceRegEx.test(onlineAmount)) {
      validationFormStatus = false;
      setOnlineAmountFormStatus("error");
      setOnlineAmountFormMessage("Amount must have 2 decimal places. Example RM 0.00");
    }
    return validationFormStatus;
  };

  const getPaymentMethod = () => {
    let method = "Cash";
    if (Number(cashAmount) > 0.0 && Number(onlineAmount) === 0.0) {
      method = "Cash";
    } else if (Number(cashAmount) === 0.0 && Number(onlineAmount) > 0.0) {
      method = "Online";
    } else if (Number(cashAmount) > 0.0 && Number(onlineAmount) > 0.0) {
      method = "Cash + Online";
    }
    return method;
  };

  const updateCashAmount = (amount: string) => {
    setCashAmountFormStatus("");
    setCashAmountFormMessage("");
    setTotalAmountFormMessage("");
    if (!priceRegEx.test(amount)) {
      setCashAmountFormStatus("error");
      setCashAmountFormMessage("Amount must have 2 decimal places. Example RM 0.00");
    }
    const newTotalPaymentAmount = Number(amount) + Number(onlineAmount);
    setTotalPaymentAmount(newTotalPaymentAmount);
    setCashAmount(amount);
  };

  const updateOnlineAmount = (amount: string) => {
    setOnlineAmountFormStatus("");
    setOnlineAmountFormMessage("");
    setTotalAmountFormMessage("");
    if (!priceRegEx.test(amount)) {
      setOnlineAmountFormStatus("error");
      setOnlineAmountFormMessage("Amount must have 2 decimal places. Example RM 0.00");
    }
    const newTotalPaymentAmount = Number(cashAmount) + Number(amount);
    setTotalPaymentAmount(newTotalPaymentAmount);
    setOnlineAmount(amount);
  };

  const updateNotes = (text: string) => {
    setNotes(text);
  };

  const isTimestampMoreThan2Hours = (timestamp: any) => {
    const createdMilliseconds = new Date(timestamp).getTime();
    const currentTimeMilliseconds = new Date().getTime();
    return currentTimeMilliseconds - createdMilliseconds > 7776000000 ? true : false;
  };

  const ableToEditBill = (timestamp: any) => {
    return bill.completed === false || !isTimestampMoreThan2Hours(timestamp);
  };

  return (
    <Layout>
      <Loader loading={loading} />
      <Sidebar collapsed={sidebarCollapsed} toggleSidebar={toggleSidebar} />
      <Content>
        <Col span={24}>
          <Header toggleSidebar={toggleSidebar} />
          <Row justify="center">
            <Col span={24}>
              <Row justify="center">
                <Col span={24} className="new-bill-container">
                  <Row>
                    <Col span={12}>
                      <Row justify="start">
                        <h3>Bill (ID: {bill.billNumber || bill.billID})</h3>
                      </Row>
                    </Col>
                    <Col span={12}>
                      <Row justify="end">
                        <h3>{new Date(bill.purchaseCreatedTimestamp).toLocaleDateString("en-GB")}</h3>
                      </Row>
                    </Col>
                  </Row>
                  <Divider style={{ margin: "12px 0" }} />
                  <Row>
                    <Col span={12}>
                      <Row justify="start">
                        <h4>Supplier Information</h4>
                      </Row>
                      {supplier.name && (
                        <Row justify="start">
                          <h4>Name: {supplier.name}</h4>
                        </Row>
                      )}
                      {supplier.companyName && (
                        <Row justify="start">
                          <h4>Company Name: {supplier.companyName}</h4>
                        </Row>
                      )}
                      {supplier.identificationCardNumber && (
                        <Row justify="start">
                          <h4>IC Number: {supplier.identificationCardNumber}</h4>
                        </Row>
                      )}
                    </Col>
                    <Col span={12}>
                      <Row justify="end">
                        <Button type="default" onClick={viewPurchase}>
                          View Purchase
                        </Button>
                      </Row>
                    </Col>
                  </Row>
                  <Divider style={{ margin: "12px 0" }} />
                  <Row>
                    <Col span={8}>
                      <Row justify="start">
                        <h4>
                          Materials List ( {numMaterials} Materials, {numWeighIns} Weigh Ins)
                        </h4>
                      </Row>
                    </Col>
                    <Col span={8}>
                      <Row justify="center">
                        <h4>Net Weight: {totalNetWeight.toFixed(1)} kg</h4>
                      </Row>
                    </Col>
                    <Col span={8}>
                      <Row justify="end">
                        <Button
                          type="default"
                          onClick={materialsBreakdown ? hideMaterialsBreakdown : showMaterialsBreakdown}
                        >
                          {materialsBreakdown ? "Hide Breakdown" : "Show Breakdown"}
                        </Button>
                      </Row>
                    </Col>
                  </Row>
                  <Row className="bill-materials-table">
                    <Col span={24}>
                      <Table
                        dataSource={materialsBreakdown ? [...materials] : [...tableFormatMaterials]}
                        columns={billColumns}
                        pagination={false}
                      />
                    </Col>
                  </Row>
                  <Row justify="end" style={{ marginTop: "10px", marginRight: "15px" }}>
                    <Col style={{ marginRight: "10px" }}>
                      <h3>Total Bill Amount:</h3>
                    </Col>
                    <Col style={{ marginRight: "30px" }}>
                      <h3>RM {totalBillAmount.toFixed(2)}</h3>
                    </Col>
                  </Row>
                  <Row justify="start">
                    <Col span={12}>
                      <Row justify="start">
                        <h4>Payment Method</h4>
                      </Row>
                      <Row justify="start">
                        <Col span={8}>
                          <h4>Cash</h4>
                        </Col>
                        <Col span={16}>
                          {!ableToEditBill(bill.createdTimestamp) ? (
                            <div style={{ width: "135px", textAlign: "right" }}>{cashAmount}</div>
                          ) : (
                            <Form.Item validateStatus={cashAmountFormStatus} help={cashAmountFormMessage}>
                              <Input
                                placeholder="0.00"
                                style={{ width: "120px", textAlign: "right" }}
                                value={cashAmount}
                                onClick={(e) =>
                                  e.currentTarget.setSelectionRange(
                                    e.currentTarget.value.length,
                                    e.currentTarget.value.length
                                  )
                                }
                                onChange={(e) => {
                                  updateCashAmount(e.target.value);
                                }}
                              />
                            </Form.Item>
                          )}
                        </Col>
                      </Row>
                      <Row justify="start" style={{ marginTop: "10px" }}>
                        <Col span={8}>
                          <h4>Online</h4>
                        </Col>
                        <Col span={16}>
                          {!ableToEditBill(bill.createdTimestamp) ? (
                            <div style={{ width: "135px", textAlign: "right" }}>{onlineAmount}</div>
                          ) : (
                            <Form.Item validateStatus={onlineAmountFormStatus} help={onlineAmountFormMessage}>
                              <Input
                                placeholder="0.00"
                                style={{ width: "120px", textAlign: "right" }}
                                value={onlineAmount}
                                onClick={(e) =>
                                  e.currentTarget.setSelectionRange(
                                    e.currentTarget.value.length,
                                    e.currentTarget.value.length
                                  )
                                }
                                onChange={(e) => {
                                  updateOnlineAmount(e.target.value);
                                }}
                              />
                            </Form.Item>
                          )}
                        </Col>
                      </Row>
                      <Row justify="start" className="amount-form-message">
                        {totalAmountFormMessage}
                      </Row>
                      <Row justify="start" style={{ marginTop: "10px" }}>
                        <Col span={8}>
                          <h3>Total Payment Amount:</h3>
                        </Col>
                        <Col span={16}>
                          <h3 style={{ marginLeft: "50px" }}>RM {totalPaymentAmount.toFixed(2)}</h3>
                        </Col>
                      </Row>
                    </Col>
                    <Col span={12}>
                      <Row justify="start">
                        <h4>Notes</h4>
                      </Row>
                      <Row>
                        <TextArea
                          showCount
                          style={{ height: 100 }}
                          onChange={(e) => updateNotes(e.target.value)}
                          placeholder="Enter bill notes"
                          value={notes}
                          disabled={!ableToEditBill(bill.createdTimestamp)}
                        />
                      </Row>
                    </Col>
                  </Row>
                  <Divider style={{ margin: "12px 0" }} />
                  <Row justify="center" style={{ marginBottom: "10px" }}>
                    <Button
                      type="primary"
                      icon={<CheckOutlined />}
                      onClick={() => validateCompleteBillForm() && completeBill()}
                      disabled={!ableToEditBill(bill.createdTimestamp)}
                    >
                      Complete Bill
                    </Button>
                  </Row>
                  {/* <Row justify="center">
                    <Button onClick={() => saveBill()} disabled={!ableToEditBill(bill.createdTimestamp)}>
                      Save Bill Draft
                    </Button>
                  </Row> */}
                </Col>
              </Row>
            </Col>
            {/* <Col span={8}>
              <Row className="previous-bills-container"></Row>
              <Row className="current-pricing-container"></Row>
            </Col> */}
          </Row>
        </Col>
        <Copyright />
      </Content>
    </Layout>
  );
};

export default NewBillPage;
